import { api } from './api';

export const communityApi = {
  meta: () => api.get('/api/community/meta'),
  listThreads: (category, page = 1) =>
    api.get(`/api/community/threads?${category ? `category=${encodeURIComponent(category)}&` : ''}page=${page}`),
  getThread: (threadId, page = 1) =>
    api.get(`/api/community/threads/${threadId}?page=${page}`),
  createThread: (data) => api.post('/api/community/threads', data),
  updateThread: (threadId, data) => api.put(`/api/community/threads/${threadId}`, data),
  deleteThread: (threadId) => api.delete(`/api/community/threads/${threadId}`),
  createReply: (threadId, body) => api.post(`/api/community/threads/${threadId}/replies`, { body }),
  updateReply: (replyId, body) => api.put(`/api/community/replies/${replyId}`, { body }),
  deleteReply: (replyId) => api.delete(`/api/community/replies/${replyId}`),
};

export const canSeeCommunity = (user) =>
  !!user && (user.role === 'admin' || user.is_community_member === true);
